import React, { useCallback, useContext } from "react";
import { FilterContext } from "../../../context";
import { closeFilterOptions } from "../subs/helpers";

const DefaultFilter = (props: {
  list: string[];
  filterName: string;
  filterLabel: string;
  filterValue: string;
  hidden?: boolean;
  extraClass?: string;
  handleFilterOptionClick: (evt: React.MouseEvent<HTMLElement>) => void;
  labelMap?: Record<string, string>;
}) => {
  const { list, filterName, filterLabel, filterValue, hidden, handleFilterOptionClick, extraClass, labelMap } = props;
  const { showFilterOptions, setShowFilterOptions } = useContext(FilterContext);

  const showFilterOptionsFn = useCallback(
    (evt: React.MouseEvent<HTMLElement>) => {
      const {
        currentTarget: { dataset },
      } = evt;
      const optionsId = dataset?.optionsUl;
      const shownClass = "showOptions";

      const optionsElement = optionsId ? document.getElementById(optionsId) : undefined;

      if (showFilterOptions && optionsElement?.classList.contains(shownClass)) {
        closeFilterOptions();
        setShowFilterOptions(false);
      } else {
        closeFilterOptions();
        optionsElement?.classList.toggle(shownClass);
        setShowFilterOptions(!showFilterOptions);
      }
    },
    [showFilterOptions, setShowFilterOptions]
  );

  //Displays options
  const onRenderOptions = ({ list, filter }: { list: Array<string>; filter: string }): JSX.Element => (
    <>
      {list?.map((item: string) => (
        <li className="default-filter-option" key={item} data-filter={filter} onClick={handleFilterOptionClick} data-value={item}>
          {labelMap?.[item] ?? item}
        </li>
      ))}
    </>
  );

  return (
    <div className={`filter ${hidden ? "hidden" : ""}`} id={`${filterName}_filter_div`}>
      <label className="filter_header" htmlFor={`${filterName}_filter`}>
        {filterLabel}
      </label>
      <div className="input_arrow" onClick={showFilterOptionsFn} data-options-ul={`${filterName}_ul`}>
        <input
          readOnly
          type="text"
          name={filterName}
          id={`${filterName}_filter`}
          className={"filter_input"}
          data-test-id="group"
          // Falls back to "" (not undefined) so this stays controlled from the very first render -
          // filterValue is often still undefined on mount, before the calling page's own
          // state/redux selector has populated it, which otherwise flips this input from
          // uncontrolled to controlled and triggers React's warning for it.
          value={labelMap?.[filterValue] ?? filterValue ?? ""}
        />
        <span className="arrow_down " />
      </div>
      <ul className={`${extraClass} filter_options`} id={`${filterName}_ul`} data-test-id={`${filterName}_list`}>
        {onRenderOptions({ list, filter: filterName })}
      </ul>
    </div>
  );
};

export default DefaultFilter;
